import { UNSUBMITTEDTIMELIST_SEARCH, UNSUBMITTEDTIMELIST_PAGE, UNSUBMITTEDTIMELIST_MAX } from '../actions/unsubmittedtimelistactions';

const state = { search: '', page: 0, max: 4 };

const getters = {
    page: state => state.page,
    search: state => state.search,
    max: state => state.max
};

const actions = {
    [UNSUBMITTEDTIMELIST_SEARCH]: ({ commit }, search) => {
        commit(UNSUBMITTEDTIMELIST_SEARCH, search);
    },
    [UNSUBMITTEDTIMELIST_PAGE]: ({ commit }, page) => {
        commit(UNSUBMITTEDTIMELIST_PAGE, page);
    },
    [UNSUBMITTEDTIMELIST_MAX]: ({ commit }, max) => {
        commit(UNSUBMITTEDTIMELIST_MAX, max);
    },
};

const mutations = {
    [UNSUBMITTEDTIMELIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [UNSUBMITTEDTIMELIST_PAGE]: (state, page) => {
        state.page = page;
    },
    [UNSUBMITTEDTIMELIST_MAX]: (state, max) => {
        state.max = max;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};